import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import { InputTextRenderer } from '../input-text.component';
import { Constants } from 'src/app/shared/utils/constants';
import { Utils } from 'src/app/shared/utils/utils';
import { GapApplicationSchemeLogicService } from 'src/app/shared/services/gap-application-scheme.logic.service';

@Component({
  selector: 'app-input-text-application-scheme',
  templateUrl: './input-text-application-scheme.component.html',
  styleUrls: ['./input-text-application-scheme.component.css']
})
export class InputTextApplicationSchemeRenderer extends InputTextRenderer {
  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;
  @Output() enableDelete = new EventEmitter<any>();
  constructor(private renderer: Renderer2, protected gapApplicationSchemeLogicService: GapApplicationSchemeLogicService) {
    super();
  }

  public override onBlur(event: any): void {
    super.onBlur(event);
    const applicationSchemeAlreadyExists: boolean = this.gapApplicationSchemeLogicService.nameAlreadyExistsOnBlur(this.params.context, this.value, this.params.fieldNameToValidate);
    this.isValid = !applicationSchemeAlreadyExists && !(this.isRequired && (this.value === undefined || this.value === null || this.value === ''));
  
    if (applicationSchemeAlreadyExists) {
      const errorMessage = this.params.fieldNameToValidate === 'mitigationName'
        ? 'The Mitigation name already exists.'
        : 'The Application Scheme name already exists.';
      Utils.showErrorMessage(errorMessage, 'Please use another name');
    }
  }

  onKeyPress(event: any) {
    Utils.omitIllegalCharacters(event, Constants.illegalCharacters);
  }

  omitIllegalCharactersOnPaste(event: any) {
    Utils.omitIllegalCharactersOnPaste(event, Constants.illegalCharacters)
  }

  onKeyUp(event: any){
    const applicationSchemeAlreadyExists:boolean = this.gapApplicationSchemeLogicService.nameAlreadyExistsOnKeyUp(this.params.context,this.value)
    this.isValid = !applicationSchemeAlreadyExists && !(this.isRequired && (this.value === undefined || this.value === null || this.value === ''));    
  }
}
